import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import { extractBlastErrorCode } from '../pages/Blasts/blastFormUtils';
import markUrl from './markUrl';
const usePublishBlast = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('blasts/publish/'), body, additional),
        onSuccess: (response) => {
            const id = response.data.blast_id;
            queryClient.setQueryData(blastKeys.detail(id), response);
            queryClient.invalidateQueries({ queryKey: blastKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: blastKeys.stats(id) });
            queryClient.invalidateQueries({ queryKey: blastKeys.validate(id) });
            return queryClient.invalidateQueries({ queryKey: blastKeys.list() });
        },
        onError: (error, request) => {
            // blast_not_* means the cached status is stale; refetch so the UI stops offering the action.
            if (extractBlastErrorCode(error)?.startsWith('blast_not_')) {
                queryClient.invalidateQueries({ queryKey: blastKeys.detail(request.blast_id) });
                queryClient.invalidateQueries({ queryKey: blastKeys.list() });
            }
        }
    });
};
export default usePublishBlast;
